import Model from "@/models/Model";

export default class Tag extends Model {
    resource() {
        return "tags";
    }

    baseURL() {
        return super.baseURL() + "/resourcecenter";
    }

    static async find(query) {
        const model = await Tag.where("id", query.id)
            .get()
            .then(res => {
                return res;
            })
            .catch(() => {
                return null;
            });

        return model;
    }

    static async findByName(name) {
        return await await Tag.where("name", name)
            .get()
            .catch(() => {
                return null;
            });
    }

    static async findItem({ id, name }) {
        if (name) {
            return this.findByName(name);
        }

        return this.find(id);
    }
}
